// src/features/owner/components/StatusDot.tsx — coloured dot indicating a service health status.
import { useTheme } from 'styled-components';
import type { HealthStatus } from '@/core/models';

export function StatusDot({ status }: { status: HealthStatus }) {
  const theme = useTheme();

  const color: Record<HealthStatus, string> = {
    operational: theme.color.success,
    degraded: theme.color.accentAmber,
    down: theme.color.danger,
  };

  return (
    <span
      title={status}
      aria-label={status}
      role="img"
      style={{
        display: 'inline-block',
        width: 8,
        height: 8,
        borderRadius: '50%',
        background: color[status],
      }}
    />
  );
}
